export default __webpack_public_path__ + "static/media/reception.8ac3c728.svg";